import React, { useEffect, useState } from 'react';

import { node } from 'prop-types';
import { useFormatMessage } from 'react-intl-hooks';
import { Link } from 'react-router-dom';

import {
  Button,
  Dropdown,
  DropdownContent,
  DropdownItem,
  DropdownTrigger,
} from '@seekube/ui-kit';

import {
  OnboardingAppFlowStepName,
  OnboardingFlowName,
  useOnboardingTracker,
} from '@/features/tracker/useOnboardingTracker';
import { useIsMobile } from '@/utils/MediaQueries';

import logo from '../../assets/svg/logo.svg';
import logoWithoutName from '../../assets/svg/logo_without_name.svg';
import { getAppBaseUrl } from '../../utils/hostname';
import styles from './styles.less';

const Header = ({ children }) => {
  const t = useFormatMessage();
  const isMobile = useIsMobile();
  const appBaseUrl = getAppBaseUrl();
  const { tracker } = useOnboardingTracker();
  const [onboardingParams, setOnboardingParams] = useState();
  useEffect(() => {
    if (!tracker) {
      return;
    }

    tracker.setFlowName(OnboardingFlowName.App);
    tracker.setOrigin('home');

    const params = new URLSearchParams();
    params.append('origin', tracker.origin);
    params.append('flowName', tracker.flowName);
    params.append('flowId', tracker.id);
    params.append('step', 1);
    setOnboardingParams(params);
  }, [tracker]);

  const seekubeLogo = isMobile ? logoWithoutName : logo;

  const loginCandidateUrl = `${appBaseUrl}/auth/login/candidate`;
  const loginRecruiterUrl = `${appBaseUrl}/auth/login/recruiter`;
  const loginOwnerUrl = `${appBaseUrl}/auth/login/owner`;

  return (
    <header className={styles.header}>
      <div className={styles.content}>
        <Link to="/">
          <img src={seekubeLogo} alt="Seekube" />
        </Link>
        <div className={styles.actions}>
          <a
            href={`${appBaseUrl}/signup?${onboardingParams}`}
            onClick={() => {
              tracker.trackStep({ name: OnboardingAppFlowStepName.Start });
            }}
          >
            <Button variant="outline" color="neutral">
              {t({ id: 'header.menu.signup_candidate' })}
            </Button>
          </a>
          <Dropdown>
            <DropdownTrigger>
              <Button variant="fill">{t({ id: 'header.menu.signin' })}</Button>
            </DropdownTrigger>
            <DropdownContent zIndex={2}>
              <DropdownItem>
                <a href={loginCandidateUrl}>{t({ id: 'header.menu.connect_candidate' })}</a>
              </DropdownItem>
              <DropdownItem>
                <a href={loginRecruiterUrl}>{t({ id: 'header.menu.connect_recruiter' })}</a>
              </DropdownItem>
              <DropdownItem>
                <a href={loginOwnerUrl}>{t({ id: 'header.menu.connect_owner' })}</a>
              </DropdownItem>
            </DropdownContent>
          </Dropdown>
        </div>
      </div>
      {children}
    </header>
  );
};

Header.propTypes = {
  children: node,
};

export default Header;
